export enum PickingListDeliveryStatus {
    WaitingConfirm = 1,
    Confirmed = 2,
    Reject = -1
}